import { useContext } from 'react';
import { Box, useTheme } from '@mui/material';
import Edit from './Edit';
import Read from './Read';
import CoverSheet from './CoverSheet';
import { ThemeContext } from '../Context';
import { ModeContext } from '../Context';
import { AppThemeWrapper } from '../ThemeWrapper';

function Central() {
  const theme = useTheme();
  const { theme: themeMode } = useContext(ThemeContext);
  const { mode } = useContext(ModeContext);

  return (
    <AppThemeWrapper>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          overflow: 'hidden'
        }}
      >
        {/* Zone de contenu défilable */}
        <Box 
          sx={{ 
            flexGrow: 1,
            overflow: 'auto',
            backgroundColor: theme.palette.background.default,
            position: 'relative' // Nécessaire pour le positionnement absolu des enfants
          }}
        >
          {/* Composant Edit - toujours monté mais masqué selon le mode */}
          <Box
            sx={{
              display: mode === 'edit' ? 'block' : 'none',
              height: '100%',
              width: '100%'
            }}
          >
            <Edit />
          </Box>

          {/* Composant Read - toujours monté mais masqué selon le mode */}
          <Box
            sx={{
              display: mode === 'read' ? 'block' : 'none',
              height: '100%',
              width: '100%'
            }}
          >
            <Read />
          </Box>

          {/* Composant CoverSheet - toujours monté mais masqué selon le mode */}
          <Box
            sx={{
              display: mode === 'emargement' ? 'block' : 'none',
              height: '100%',
              width: '100%'
            }}
          >
            <CoverSheet />
          </Box>
        </Box>
      </Box>
    </AppThemeWrapper>
  );
}

export default Central;



